export default "<div class=\"app-session\">\n  <app-page></app-page>\n  <app-loading [loading]=\"loading\"></app-loading>\n</div>\n"